import {AfterContentInit, Component, Input} from "@angular/core";
import {AccordionGroupComponent} from './accordion.group.component';

@Component({
    selector: 'accordion',
    template: require('./accordion.template.html')
})
export class AccordionComponent implements AfterContentInit {

    @Input('close-others')
    closeOthers = true;

    @Input('show-arrows')
    showArrows = false;

    @Input('expand-all')
    expandAll = false;

    private groups: Array<AccordionGroupComponent> = [];

    ngAfterContentInit() {
        if (this.expandAll) {
            this.closeOthers = false;
            this.openAll();
        }
    }

    closeAll() {
        this.setAllGroupsState(false);
    }

    openAll() {
        this.setAllGroupsState(true);
    }

    private setAllGroupsState(state: boolean) {
        this.groups.forEach((group: AccordionGroupComponent) => {
            group.isOpened = state;
        });
        this.updateGroups();
    }

    registerGroup(childGroup: AccordionGroupComponent) {
        this.groups.push(childGroup);
        // setTimeout(()=>{
            if (childGroup.isOpened) {
                childGroup.isOpened = false;
                this.selectGroup(childGroup);
            } else {
                this.updateGroups();
            }
        // });
    }
    
    selectGroup(group: AccordionGroupComponent) {
        const isOpenedBeforeWeChange = group.isOpened;
        if (this.closeOthers) {
            this.closeAll();
        }
        group.isOpened = !isOpenedBeforeWeChange;
        this.updateGroups();
    }

    updateGroups() {
        this.groups.forEach((group: AccordionGroupComponent) => group.updateView());
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/accordion/accordion.component.ts